import React, { forwardRef } from 'react'

import {
  errorClasses,
  getBoxShadowClasses,
  helperClasses,
  inputBaseClasses,
  labelClasses,
} from '@/app/components/Form/styles'
import { cn } from '@/app/utils/style'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  helperText?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className, id, required, ...props }, ref) => {
    const inputId = id || `input-${label?.toLowerCase().replace(/\s+/g, '-')}`

    return (
      <div className="flex flex-col gap-sm">
        {label && (
          <label htmlFor={inputId} className={cn(labelClasses)}>
            {label}
            {required && <span className="text-red-500 ml-xs">*</span>}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(inputBaseClasses, getBoxShadowClasses(error), className)}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={
            error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined
          }
          required={required}
          onFocus={(e) => {
            props.onFocus?.(e)
          }}
          onBlur={(e) => {
            props.onBlur?.(e)
          }}
          {...props}
        />
        {error && (
          <span id={`${inputId}-error`} className={errorClasses}>
            {error}
          </span>
        )}
        {!error && helperText && (
          <span id={`${inputId}-helper`} className={helperClasses}>
            {helperText}
          </span>
        )}
      </div>
    )
  },
)

Input.displayName = 'Input'
